import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useCreateTeamMutation } from "../../features/team/teamApi";

export default function ModalForAddingTeam({ setModal }) {
  const [teamName, setTeamName] = useState("");
  const [description, setDescription] = useState("");
  const [color, setColor] = useState("");
  const { user: loggedInUser } = useSelector((state) => state.auth) || {};
  const { email: myEmail } = loggedInUser || {};
  const [createTeam, { isSuccess }] = useCreateTeamMutation();
  useEffect(() => {
    if (isSuccess) {
      setModal(false);
    }
  }, [isSuccess, setModal]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const date = new Date().toLocaleDateString("en-us", {
      month: "short",
      day: "numeric",
    });
    if (teamName !== "" && description !== "") {
      const data = {
        name: teamName,
        date: date,
        owner: myEmail,
        color: color,
        description: description,
        members: [myEmail],
      };
      createTeam(data);
    }
  };

  return (
    <>
      <div className="fixed w-full h-full inset-0 z-10 bg-black/50 cursor-pointer"></div>
      <div className="rounded w-[400px] lg:w-[600px] space-y-8 bg-white p-10 absolute top-1/2 left-1/2 z-20 -translate-x-1/2 -translate-y-1/2">
        <span
          onClick={() => setModal(false)}
          className="absolute cursor-pointer top-[-4px] text-xl text-white right-[-3px] bg-red-400 rounded-2xl py-1 text-center font-bold px-3"
        >
          X
        </span>
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Add New Team
        </h2>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="name" className="sr-only"></label>
              <input
                id="name"
                name="name"
                type="text"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
                placeholder="Team Name"
                onChange={(e) => setTeamName(e.target.value)}
              />
            </div>
            <div>
              <label htmlFor="description" className="sr-only">
                Description
              </label>
              <textarea
                id="description"
                name="description"
                type="text"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
                placeholder="Team Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
            <div className="text-start">
              <span className="font-bold mt-1">Team Color:</span>

              <div className="flex gap-1 items-center">
                <input
                  onChange={(e) => setColor(e.target.value)}
                  type="radio"
                  name="color"
                  value="red"
                />{" "}
                Red
                <input
                  onChange={(e) => setColor(e.target.value)}
                  type="radio"
                  name="color"
                  value="blue"
                />{" "}
                Blue
                <input
                  onChange={(e) => setColor(e.target.value)}
                  type="radio"
                  name="color"
                  value="yellow"
                />{" "}
                Yellow
                <input
                  onChange={(e) => setColor(e.target.value)}
                  type="radio"
                  name="color"
                  value="pink"
                />{" "}
                Pink
                <input
                  onChange={(e) => setColor(e.target.value)}
                  type="radio"
                  name="color"
                  value="green"
                />{" "}
                Green
              </div>
            </div>
          </div>

          <div>
            <button
              type="submit"
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
            >
              Add Team
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
